'use client';

import { useLayoutContext } from '@/components/Layout/LayoutProvider';
import PhoneIcon from '@/components/Icons/PhoneIcon';

const formatPhoneHref = (phone?: string | null) => {
  if (!phone) return '';
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
};

export default function NotFoundHero({
  isReducedBrandSite = false,
}: {
  isReducedBrandSite: boolean;
}) {
  const { callRailPhone } = useLayoutContext();
  const phoneHref = formatPhoneHref(callRailPhone);

  return (
    <section className='w-full'>
      <div className='mx-auto grid max-w-[1248px] grid-cols-1 px-5 py-15 md:px-8 md:pt-14 md:pb-16 lg:grid-cols-[minmax(0,1fr)_360px] lg:gap-x-16 lg:px-10 lg:pt-31 lg:pb-30'>
        <div>
          <h1 className='max-w-[530px] text-[40px] leading-[0.92] font-semibold tracking-[-0.03em] text-primary-500 md:text-[60px]'>
            <span className='text-hero-text-highlight'>Oops!</span> Something went wrong.
          </h1>
        </div>

        {!isReducedBrandSite && (
          <div className='mt-9 max-w-[360px] lg:mt-2 lg:justify-self-end'>
            <p className='text-primary-500 text-[18px] leading-[27.9px] max-w-[270px] lg:max-w-full'>
              Don’t worry, we’re here to help. Check out our services or give us a call.
            </p>

            {callRailPhone && (
              <>
                <a
                  href={phoneHref}
                  className='mt-3 hidden items-center gap-2 text-[18px] font-semibold text-primary-500 transition-opacity hover:opacity-80 md:inline-flex'
                >
                  <PhoneIcon className='size-4 text-hero-text-highlight' />
                  <span>{callRailPhone}</span>
                </a>

                <a
                  href={phoneHref}
                  className='heading-6 mt-9 flex w-full items-center justify-center gap-2 rounded-lg bg-secondary-500 px-8 py-4 text-white transition-colors duration-200 hover:bg-secondary-700 md:hidden'
                >
                  <PhoneIcon className='size-4 text-white' />
                  Call Now
                </a>
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
